export const STATUS_FAILED = "failed";

export const USER_ROLES = {
  Regional_Planner: "Regional Planner",
  Team_Leader: "Team Leader",
  Regional_Supervisor: "Regional Supervisor",
  HQ_Planner: "HQ Planner",
  Regional_Operation_Manager: "Regional Operation Manager",
  Dispatcher: "Dispatcher",
  Regional_Coordinator: "Regional Coordinator",
  Inspector: "Inspector",
};

export const COLUMN_TITLES = {
  'Tasks': [
    {key: "Not Started", title: "Not Started"},
    {key: "In Progress", title: "In Progress"},
    {key: "Rejected", title: "Rejected"},
    {key: "Admin Review", title: "Admin Review"},
    {key: "Completed", title: "Completed"},
    // {key: "Non-executable", title: "Non-executable"},
    {key: "Cancelled", title: "Cancelled"}
  ],
  'Tickets': [
    {key: "Not Started", title: "Not Started"},
    {key: "In Progress", title: "In Progress"},
    {key: "Completed", title: "Completed"},
    {key: "Cancelled", title: "Cancelled"},
  ]
};

export const BOARD_STATUSES = {
  "Not Started": "Pending",
  "In Progress": "Work",
  "Rejected": "Error",
  "Admin Review": "Review",
  "Completed": "Success",
  "Non-executable": "Default",
  "Cancelled": "Cancelled",
}

export const BOARD_TICKETS = {
  'Tasks': {
    "Not Started": [],
    "In Progress": [],
    "Rejected": [],
    "Admin Review": [],
    "Completed": [],
    "Non-executable": [],
    "Cancelled": [],
  },
  'Tickets': {
    "Not Started": [],
    "In Progress": [],
    "Completed": [],
    "Cancelled": [],
  }
};

export const SKIPPED_COLUMNS = ["Not Started", "Rejected"];

export const USERS_CAN_CRATE_TICKET = ["Administrator", "User", "OperationRoom"];

export const TICKET_SYSTEMS_ROLES = [...USERS_CAN_CRATE_TICKET, 'ExternalUser']
export const AUDIT_ROLES = ["Administrator", "Inspector", 'QualityAssurance', "ReadOnlyAdmin", "Supervisor"]